import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";

const Programs = ({ activeTab }) => {
    // Create Refs for Each Section
    const educationRef = useRef(null);
    const enrollmentRef = useRef(null);
    const housingRef = useRef(null);
    const permitsRef = useRef(null);
    const socialServicesRef = useRef(null);

    // Scroll to the selected section when activeTab changes with 30px offset
    useEffect(() => {
        if (activeTab) {
            let sectionRef = null;
            switch (activeTab) {
                case "Education":
                    sectionRef = educationRef;
                    break;
                case "Enrollment":
                    sectionRef = enrollmentRef;
                    break;
                case "Housing Programs":
                    sectionRef = housingRef;
                    break;
                case "Permits":
                    sectionRef = permitsRef;
                    break;
                case "Social Services":
                    sectionRef = socialServicesRef;
                    break;
                default:
                    sectionRef = null;
            }

            if (sectionRef && sectionRef.current) {
                const yOffset = -260; // Adjust this value for the offset
                const y = sectionRef.current.getBoundingClientRect().top + window.scrollY + yOffset;
                window.scrollTo({ top: y, behavior: "smooth" });
            }
        }
    }, [activeTab]);

    return (
        <div className="max-w-5xl mx-auto p-6 bg-white shadow-md rounded-lg">
            <h1 className="text-3xl font-bold mb-4">Programs and Services</h1>
            <p className="text-gray-700 mb-6">
                Welcome to Programs Portal. Scroll down to review programs and services provided.
            </p>

            {/* Education Section */}
            <div ref={educationRef} className="mb-6">
                <h2 className="text-xl font-bold mb-2">Education</h2>
                <p className="text-gray-700">
                    The mission of the CCTH Department of Education is to provide opportunities to promote lifelong learning among all tribal citizens.
                    The Education Department also provides educational services to other Native Americans in the{" "}
                    <Link to="https://www.example.com" className="text-blue-600 underline">ten-county service</Link> area who are attending public schools.
                </p>
                <Link to="" className="text-blue-600 underline block mt-2">Apply Now</Link>
            </div>

            {/* Enrollment Section */}
            <div ref={enrollmentRef} className="mb-6">
                <h2 className="text-xl font-bold mb-2">Enrollment</h2>
                <p className="text-gray-700">
                    As of February 21, 2021, the CCTH of Potawatomi Indians will be requiring DNA testing for applicants.
                </p>
                <p className="text-gray-700">
                    For more information call{" "}
                    <a href="tel:+12697821763" className="text-blue-600 underline">(269) 782-1763</a> 
                    {" "}or email us at{" "}
                    <a href="mailto:Enrollment.Requests@CCTH-nsn.gov" className="text-blue-600 underline">
                        Enrollment.Requests@CCTH-nsn.gov
                    </a>.
                </p>
                <Link to="/apply?tab=Enrollment" className="text-blue-600 underline block mt-2">Apply Now</Link>
            </div>

            {/* Housing Programs Section */}
            <div ref={housingRef} className="mb-6">
                <h2 className="text-xl font-bold mb-2">Housing Programs</h2>
                <ul className="list-disc list-inside text-gray-700 mt-2">
                    <li>Home purchasing</li>
                    <li>Loan assistance</li>
                    <li>Installation or improvements of well and/or sewer services</li>
                </ul>
                <Link to="" className="text-blue-600 underline block mt-2">Apply Now</Link>
            </div>

            {/* Permits Section */}
            <div ref={permitsRef} className="mb-6">
                <h2 className="text-xl font-bold mb-2">Permits</h2>
                <ul className="list-disc list-inside text-gray-700 mt-2">
                    <li>Hunting, fishing, and gathering permits are required for harvesting activities on Tribal properties.</li>
                    <li>Permits and licenses expire each year on March 31st.</li>
                </ul>
                <Link to="" className="text-blue-600 underline block mt-2">Apply Now</Link>
            </div>

            {/* Social Services Section */}
            <div ref={socialServicesRef} className="mb-6">
                <h2 className="text-xl font-bold mb-2">Social Services</h2>
                <p className="text-gray-700">
                    We strive to assist families in maintaining strength in a healthy community structure.
                </p>
                <Link to="" className="text-blue-600 underline block mt-2">Apply Now</Link>
            </div>
        </div>
    );
};

export default Programs;
